import { DEFAULT_PIE_CHART_HEIGHT } from 'src/Libs/system-charts/default-charts/pie-chart-constants'

/**
 * calculates the inner and outer radius of a pie chart based on the given height and width of the chart
 * for smaller views slightly different values are used
 * @param chartHeight
 * @param chartWidth
 * @returns the inner and outer radius for a pieChart
 */
export const getRadius = (chartHeight: number, chartWidth: number): { outerRadius: number; innerRadius: number } => {
  const baseHeight = chartHeight ?? DEFAULT_PIE_CHART_HEIGHT
  const baseWidth = chartWidth ?? DEFAULT_PIE_CHART_HEIGHT
  const radiusBase = Math.min(baseHeight, baseWidth) / 2

  return {
    outerRadius: radiusBase - 3,
    innerRadius: radiusBase - 13,
  }
}

export const getRoundedValue = (value: number, isKiloUnit?: boolean): number => {
  return isKiloUnit ? Math.round((value / 1000) * 100) / 100 : Math.round(value * 10) / 10
}
